// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'swipe-right';

export const Component = () => (
  <path d='m21.121 7.37 3.4-3.161L21.121 1l-.67.814 2.107 1.963h-7.855v1.006h7.855L20.45 6.65l.67.719ZM4.36 15.08l4.454 3.4V4.687c0-1.102.43-1.628 1.34-1.628.431 0 .814.143 1.15.478.334.288.478.67.478 1.15v7.854l7.903 3.018v7.854H7.854l-5.747-5.986c-.335-.527-.479-1.006-.335-1.533.096-.527.431-.958 1.005-1.198.527-.287 1.054-.144 1.58.383h.002ZM8.38 2.867c-.431.527-.622 1.102-.526 1.82v11.83l-3.496-2.442c-.623-.431-1.246-.479-1.868-.191-.67.239-1.15.814-1.39 1.676-.287.862-.19 1.677.336 2.442l5.411 6.37H20.64v-9.818l-7.902-2.97V4.688c0-.72-.239-1.341-.766-1.82a2.399 2.399 0 0 0-1.82-.814c-.67 0-1.245.287-1.772.814ZM0 3.777v1.006h5.843V3.777H0Z' />
);

export const viewBox = '0 0 25 25';
